/* 10X Daily page script. Day picker, session views, form checks, Klaviyo client subscribe.
   The subscribe call (endpoint, revision, body) is carried over unchanged from the page build's tested section
   (assets/10x-daily.js on feat/10x-daily-standalone-page, d71e013). */
(function () {
  'use strict';
  function $(s, r) { return (r || document).querySelector(s); }
  function $all(s, r) { return [].slice.call((r || document).querySelectorAll(s)); }

  /* ---------- the day picker: the visitor's date in Asia/Dubai, then the week cards ---------- */
  var days = $all('.xd-day');
  function show(i) {
    days.forEach(function (d, k) { d.hidden = (k !== i); });
    var sec = document.getElementById('today');
    if (sec && days[i]) sec.setAttribute('data-title', days[i].getAttribute('data-title'));
  }
  try {
    var iso = new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Dubai' }).format(new Date());
    var k = days.findIndex(function (d) { return d.getAttribute('data-date') === iso; });
    var label = '';
    if (k < 0 && days.length) {
      /* no panel for today: show the nearest earlier panel (Latest session), or the first one when none is earlier (First session) */
      var best = '';
      days.forEach(function (d, n) { var dd = d.getAttribute('data-date') || ''; if (dd && dd < iso && dd > best) { best = dd; k = n; } });
      if (best) { label = 'Latest session'; } else { k = 0; label = 'First session'; }
    }
    if (k >= 0) show(k);
    if (label) { var h = $('#today .xd-h2'); if (h) h.textContent = label; }
  } catch (e) {}

  /* ---------- today's session: the two views (full session and stepping-stone version) ---------- */
  $all('.xd-viewbtn').forEach(function (b) {
    b.addEventListener('click', function () {
      var day = b.closest('.xd-day'), v = b.getAttribute('data-view');
      $all('.xd-viewbtn', day).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      $all('.xd-view', day).forEach(function (p) { p.hidden = (p.getAttribute('data-view') !== v); });
    });
  });

  /* ---------- the sign-up: first name, email and one consent tick; no gate, no goal choice ---------- */
  var root = document.getElementById('sunday');
  var form = document.getElementById('signup');
  if (!root || !form) return;
  var status = document.getElementById('send-err'), submit = $('button[type=submit]', form);
  function clean(v) { return String(v || '').replace(/\s+/g, '').replace(/^mailto:/i, ''); }   // a pasted "mailto:" and any spaces never reach the address
  var fields = [['fn', function (i) { return i.value.trim().length > 0; }],
                ['em', function (i) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(clean(i.value)); }],
                ['ck', function (i) { return i.checked; }]];
  function check(id, ok) { var i = document.getElementById(id), e = document.getElementById(id + '-err'), good = ok(i); e.hidden = good; i.setAttribute('aria-invalid', good ? 'false' : 'true'); return good; }
  var sending = false;
  submit.addEventListener('pointerdown', function () { sending = true; });
  fields.forEach(function (f) {
    var i = document.getElementById(f[0]);
    i.addEventListener(f[0] === 'ck' ? 'change' : 'blur', function (ev) { if (f[0] === 'em') i.value = clean(i.value); if (sending || (ev.relatedTarget === submit)) return; check(f[0], f[1]); });
  });

  var API = 'https://a.klaviyo.com/client/subscriptions/?company_id=';
  var REVISION = '2026-10-15';
  /* The sign-up posts to the funnel Worker first (consent text and UTM travel with it). SITE_TOKEN is the public
     site token, the same value as sections/footer-10x.liquid. The direct Klaviyo call above stays as the fallback. */
  var WORKER_URL = 'https://10x-funnel.10xpformance.workers.dev/webhooks/magnet-optin';
  var SITE_TOKEN = '456afc944f94440dc09e2e8131910c452155c64117e59274dd8679b838043dc6';
  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    sending = false;
    var emailEl = document.getElementById('em'); emailEl.value = clean(emailEl.value);
    var ok = true;
    fields.forEach(function (f) { if (!check(f[0], f[1])) ok = false; });
    status.hidden = true;
    if (!ok) { var bad = $('[aria-invalid="true"]', form); if (bad) bad.focus(); return; }
    var email = form.elements.email;
    var utm = {};
    var params = new URLSearchParams(window.location.search);
    UTM_KEYS.forEach(function (k) {
      var v = params.get(k);
      if (v) utm[k] = v.slice(0, 100);
    });
    var props = {
      lead_source: root.getAttribute('data-lead-source'),
      disclaimer_version: root.getAttribute('data-version')
    };
    Object.keys(utm).forEach(function (k) { props[k] = utm[k]; });
    var attrs = { email: clean(email.value), properties: props };
    var first = form.elements.first_name.value.trim();
    if (first) attrs.first_name = first;
    var body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: '10X Daily page',
          profile: { data: { type: 'profile', attributes: attrs } }
        },
        relationships: { list: { data: { type: 'list', id: root.getAttribute('data-list-id') } } }
      }
    };
    var consentEl = $('label.xd-check');
    var workerBody = {
      email: clean(email.value),
      source: 'web_form',
      consent_text: (consentEl ? consentEl.textContent : '').replace(/\s+/g, ' ').trim(),
      disclaimer_version: root.getAttribute('data-version')
    };
    if (first) workerBody.first_name = first;
    if (Object.keys(utm).length) workerBody.utm = utm;
    submit.disabled = true;
    function subscribeDirect() {
      return fetch(API + encodeURIComponent(root.getAttribute('data-company-id')), {
        method: 'POST',
        headers: { 'content-type': 'application/json', revision: REVISION },
        body: JSON.stringify(body)
      }).then(function (res) {
        if (res.status !== 202 && !res.ok) throw new Error('klaviyo subscribe failed: ' + res.status);
      });
    }
    fetch(WORKER_URL, {
      method: 'POST',
      headers: { 'content-type': 'application/json', 'x-site-token': SITE_TOKEN },
      body: JSON.stringify(workerBody)
    }).then(function (res) {
      if (res.ok) return;
      if (res.status === 404) return subscribeDirect();   // Worker route not deployed yet: the direct call keeps the page working
      throw new Error('worker magnet-optin failed: ' + res.status);
    }, function () {
      return subscribeDirect();                            // the Worker request itself failed (network)
    }).then(function () {
      form.hidden = true; document.getElementById('confirm').hidden = false;
      document.getElementById('confirm').scrollIntoView({ block: 'nearest' });
    }).catch(function () {
      submit.disabled = false;
      status.hidden = false;
    });
  });
})();
